
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#4FA2B7","fill-rule":"nonzero","cx":"22.5","cy":"22.5","r":"22.5"}}),_c('path',{attrs:{"d":"M32.244 14.067c-.641-.612-2.523-.941-4.515-1.29-1.13-.198-2.3-.402-3.168-.653-1.792-.518-4.79.7-6.98 1.59-.792.322-1.476.6-1.91.714-1.97.521-3.104 1.569-5.06 4.67-.698 1.107-2.272 5.653-1.305 7.848l.071.164c.529 1.21 1.932 4.426 4.286 5.64C15.613 33.756 21.743 35 23.802 35c.175.006.35-.01.521-.047 5.067-1.395 7.24-2.345 9.347-4.9 1.042-1.264 2.453-7.324 2.321-9.276-.08-1.189-2.497-5.515-3.747-6.709","fill":"#FFF"}}),_c('path',{attrs:{"d":"M25.174 19.3c-2.113 2.685-4.208 3.64-9.432 5.147-1 .288-8.372-1.11-10.666-2.352-2.277-1.23-3.681-4.6-4.21-5.869l-.075-.179c-.919-2.186.653-6.937 1.32-8.045 1.945-3.233 3.053-4.318 4.937-4.84.485-.135 1.21-.444 2.05-.8 1.854-.79 4.287-1.826 6.009-1.826.295-.005.59.034.875.115.93.282 2.159.507 3.347.725 1.897.348 3.859.707 4.406 1.256C25.006 3.903 27.4 8.515 27.47 9.58c.125 1.948-1.318 8.477-2.295 9.719m2.81-9.753c-.084-1.291-2.59-5.989-3.885-7.285-.662-.662-2.613-1.02-4.678-1.399-1.174-.215-2.388-.437-3.29-.711-1.854-.56-4.963.763-7.234 1.73-.823.35-1.533.652-1.985.777-2.038.565-3.214 1.703-5.242 5.072C.947 8.933-.685 13.868.317 16.25l.074.177c.548 1.315 2.003 4.808 4.441 6.126C6.853 23.647 13.211 25 15.344 25a2.11 2.11 0 00.54-.052c5.255-1.515 7.51-2.547 9.694-5.323 1.05-1.336 2.538-8.012 2.405-10.077","fill":"#FFF","mask":"url(#mask-2)","transform":"translate(9 11)"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/cellFill.svg